import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 450,
    minHeight: 180,
    padding: 15,
    background: '#F2F4F8',
    borderRadius: 2,
    [theme.breakpoints.down(768)]: {
      maxWidth: '100%',
      minHeight: 0,
      padding: '15px 7px',
    },
  },
  contentBox: {
    width: '100%',
  },
  name: {
    margin: 0,
    marginBottom: 5,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  nameOffset: {
    marginBottom: 20,
  },
  role: {
    display: 'block',
    marginBottom: 20,
    fontSize: 14,
    color: '#626262',
  },
  description: {
    fontSize: 15,
    fontWeight: 500,
    color: '#333',
  },
  photo: {
    marginLeft: 20,
    display: 'block',
    maxWidth: 150,
    maxHeight: 150,
    [theme.breakpoints.down(475)]: {
      maxWidth: 100,
      maxHeight: 100,
      marginLeft: 10,
    },
  },
  mail: {
    marginBottom: 5,
  },
  link: {
    display: 'block',
    width: '100%',
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    textDecoration: 'none',
  },
  input: {
    display: 'block',
    width: '100%',
    margin: 0,
    padding: 0,
    fontSize: 14,
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    color: `${theme.custom.darkBlue} !important`,
    textDecoration: 'none',
    border: 0,
    background: 'transparent',
    '&:disabled': {
      color: theme.custom.darkBlue,
    },
  },
  bold: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  emergency: {
    marginTop: 5,
  },
}));
